export default function pluralise(text, count) {
  return `${text}${count === 1 ? '' : 's'}`
}
